const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsProdutos = { name: 'Produtos', pathName: null, action: 'produtos' }

export default [
  {
    path: 'comparativo-produtos',
    name: 'comparativo-produtos',
    component: () => import('@/modules/produtos/comparativo/views/pages/ComparativoDeProdutos.vue'),
    meta: {
      breadcrumbs: [
        breadcrumbsHome,
        breadcrumbsProdutos,
        {
          name: 'Comparativo de produtos',
          pathName: null,
        },
      ],
      title: 'Comparativo de produtos',
      allowOnlyMercapromo: true,
      requiredUserPermissions: ['produtos/comparativo_produtos'],
    },
  },
]
